<template>
    <div class="display-screen" :style="[screenHeight ? {'height': `${screenHeight}px`} : null]">
        <slot />
    </div>
</template>

<script>
export default {
    name: "DisplayScreen",
    props: {
        screenHeight: String|null
    }
};
</script>
